import React from "react";
import "./KitchenCleaningService.css";

const KitchenCleaningService = () => {
  return (
    <div className="kitchencleaning-cleaning-container">
      <h1>Spotless, Sanitized, and Sparkling Kitchen</h1>
      <p>
        We'll thoroughly clean and sanitize all countertops, sinks, and
        backsplashes. We'll also clean inside and outside of all appliances,
        including the refrigerator, oven, and microwave.
      </p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Sanitize all countertops, sinks, and backsplashes</li>
        <li>Clean inside and outside of refrigerator</li>
        <li>Clean inside and outside of oven</li>
        <li>Clean inside and outside of microwave</li>
        <li>Wipe down cabinet exteriors and appliances</li>
      </ul>
    </div>
  );
};

export default KitchenCleaningService;
